import { useEffect } from 'react';

type Props = {
  open: boolean;
  onClose?: () => void;
  onOpenChange?: (open: boolean) => void;
};

export function PopoverStateChangedEffect({
  open,
  onClose,
  onOpenChange,
}: Props) {
  useEffect(() => {
    onOpenChange?.(open);
    if (!open) {
      onClose?.();
    }
  }, [open]);

  return null;
}
